// extracted by mini-css-extract-plugin
module.exports = {"name":"name-17OXd"};